import React, { useEffect } from "react";
import { FaStar } from "react-icons/fa";
import { Col, Container, Row } from "reactstrap";
import BlogNav from "../Blog/BlogNav";
import AnimationCommon from "../common/AnimationCommon";
import CustomBreadcrumb from "../common/Breadcrumb";
import Footer from "../components/footer";

const Review = () => {
  useEffect(() => {
    document.body.classList.remove("landing-page");
    document.body.classList.add("inner-page");
  }, []);

  return (
    <div>
      <BlogNav />
      <div className='page-margin'>
        <CustomBreadcrumb items={"Review"} title={'Review'}/>
        <section className='review-block blog-page'>
          <Container>
            <Row className='margin-bottom'>
              {[...Array(6)].map((_, i) => (
                <Col lg='4' md='6' key={i}>
                  <div className='review-box'>
                    <img src={`assets/images/review.png`} alt='review' className='img-fluid' />
                    <h5>John Martin</h5>
                    <div className='rating-star'>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <FaStar key={index} className="star"/>
                      ))}
                    </div>
                    <div className='review-message'>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
          <AnimationCommon />
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default Review;
